import classnames from 'classnames';
import '../resources/css/cascade.css';
import Separator from './shared/Separator';
import parse from 'html-react-parser';

export default function Cascade({ data }) {

    const renderImages = function (images) {
        return images?.map(image => <div className="cascade-row-cell" key={image} style={{ backgroundImage: `url(${image})` }}>

        </div>)
    }

    const cascade = data?.content?.rows.map((row, index) => {
        return <div className="cascade-row" key={index}>
            <div className="cascade-row-content">

                {index % 2 === 1 ? renderImages(row.images) : null}

                <div className="cascade-row-cell">
                    <div className="cascade-row-text">
                        <div className="title-h2">{row.title}</div>
                        <Separator className={row.style}></Separator>
                        <div className="cascade-text-description">{row.description}</div>
                        <div>{parse(row.content)}</div>
                    </div>
                </div>

                {index % 2 === 0 ? renderImages(row.images) : null}

            </div>
            <div className={classnames('cascade-row-border', row.style)}></div>
        </div>;
    });

    console.log(data);

    return (
        <div className="cascade-wrapper">
            <div className="cascade">
                {cascade}
            </div>
        </div>
    );
}